<template id="village-list-template">
  <slot
    name="content"
    :showMobileMap="showMobileMap"
    :showFullMap="data.showFullMap"
    :showMoreEvents="data.showMoreEvents"
    :tileClick="tileClick"
    :showInfoPackForm="showInfoPackForm"
    :mapCentre="data.mapCentre"
    :mapZoom="data.mapZoom"
    :villageList="data.villageList"
    :paginator="data.paginator"
    :isLoading="data.isLoading"
    :saveRemoveFavourite="saveRemoveFavourite"
    :paginationText="paginationText"
    :shouldStick="data.shouldStick"
    :showSeoReadMore="data.showSeoReadMore"
    :triggerReadLess="triggerReadLess"
    :clickTile="clickTile"
    :showPropertyListModal="showPropertyListModal"
    :controls="data.controls"
  ></slot>
</template>
<script setup>
import {defineProps, reactive, onMounted, watch, nextTick, onBeforeMount, computed} from 'vue'
import axios from 'axios'
import useGlobalStore from '../../store/globalStore'
import {useCommon} from '../../composables/useCommon';
import {useFormSubmit} from '../../composables/useFormSubmit'

const { productImpression } = useCommon()
const { assignHiddenFields, pushTileClickData, clickTile, saveRemoveFavourite } = useFormSubmit()

const props = defineProps({
  selectedTypeOfHomesList: {
    type: Array,
    default: [],
  },
  defaultTypeOfHomesList: {
    type: Array,
    default: [],
  },
  selectedPriceRangeList: {
    type: Array,
    default: [],
  },
  selectedPriceRangeServicedList: {
    type: Array,
    default: [],
  },
  defaultPriceRangeList: {
    type: Array,
    default: [],
  },
  selectedLevelOfCareList: {
    type: Array,
    default: [],
  },
  defaultLevelOfCareList: {
    type: Array,
    default: [],
  },
  selectedVillageSizeList: {
    type: Array,
    default: [],
  },
  defaultVillageSizeList: {
    type: Array,
    default: [],
  },
  defaultVillageList: {
    type: Array,
    default: [],
  },
  defaultSuburbUrl: {
    default: '',
  },
  checkedOptions: {
    type: Array,
    default: [],
  },
  eventsCount: {
    type: Number,
    default: 0,
  },
  selectedRegion: {
    default: 0,
  },
  selectedDistrict: {
    default: 0,
  },
  selectedSuburbs: {
    type: Array,
    default: [],
  },
  type: {
    type: String,
    default: 'villages',
  },
  impressionList: {
    type: Object,
    default: () => {},
  },
});

// Data properties
const globalStore = useGlobalStore()
const data = reactive({
  showTypeOfHomes: false,
  showPriceRange: false,
  showLevelOfCare: false,
  typeOfHomesList: props.selectedTypeOfHomesList,
  entryAgeList: [],
  priceRangeList: props.selectedPriceRangeList,
  priceRangeIndependentList: [],
  priceRangeServicedList: props.selectedPriceRangeServicedList,
  levelOfCareList: props.selectedLevelOfCareList,
  villageSizeList: props.selectedVillageSizeList,
  showEnquiryId: false,
  showMobileFilters: false,
  showSeoReadMore: false,
  suburbSelectAll: false,
  suburbs: props.checkedOptions,
  suburbUrl: props.defaultSuburbUrl,
  controls: [
    '<i class=\'icon icon--arrow-left\'></i>',
    '<i class=\'icon icon--arrow-right\'></i>'
  ],
  showMap: false,
  showFullMap: false,
  shouldStick: true,
  isMobileFilterOn: false,
  districtList: [],
  villageList: [],
  paginator: {},
  isLoading: false,
  mapCentre: {},
  mapZoom: 8,
});

// Methods
const togglePriceRange = () => {
  data.showPriceRange = !data.showPriceRange;
  data.showTypeOfHomes = false;
  data.showLevelOfCare = false;
};

const toggleLevelOfCare = () => {
  data.showLevelOfCare = !data.showLevelOfCare;
  data.showTypeOfHomes = false;
  data.showPriceRange = false;
};

const isChecked = (arrayIds, id) => {
  const data = arrayIds.filter(function (el) {
    return parseInt(el, 10) === parseInt(id, 10);
  });

  return (data.length > 0);
};

const showInfoPackForm = async (villageId, villageName, action, e) => {
  globalStore.setModal(
    {
      name: 'villageInfoPackModal',
      id: villageId,
      customField: action,
      title: villageName,
      descriptionPlaceholder: `Please send me an information pack for ${villageName}`,
    }
  )

  localStorage.setItem('preSiteTitle', document.title);
  await nextTick()
  const ele = e.target;
  if (ele.dataset.metaTitle) {
    document.title = ele.dataset.metaTitle;
  }
  villageName = villageName.replace(' - Open day', '');
  document.getElementById('property_name').value = villageName;
  assignHiddenFields(ele);
};

const tileClick = (id, e) => {
  const ele = e.target.closest(`#tile_${id}`);
  pushTileClickData(ele);
};

const showFreeCopyForm = (type) => {
  globalStore.setModal(
    {
      name: 'freeCopy',
      customField: type,
    }
  )
};

const saveAdvertPromotion = (e) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'promotionClick',
    'ecommerce': {
      'promoClick': {
        'promotions': [
          {
            'id': 1,
            'name': 'quail ridge country club',
            'creative': 'quail-banner-01',
            'position': 'banner1',
          }],
      },
    },
  });

  const win = window.open(e.target.dataset.url, '_blank');
  win.focus();
};

const triggerReadMore = () => {
  data.showSeoReadMore = true;
};

const triggerReadLess = () => {
  data.showSeoReadMore = false;
};

const expandMap = () => {
  data.showFullMap = !data.showFullMap;
  //data.$refs.downloadGuide.style.top = 'auto';
};

const showMobileMap = () => {
  data.showMap = !data.showMap
  data.showFullMap = !data.showFullMap;
};

const tinySliderPagination = (e) => {
  const sliderInfo = data.$refs[`tinySlider${e.target.dataset.propertyId}`].slider.getInfo();
};

// Computed
const paginationText = computed(() => {
  if (data.paginator.currentPage === undefined) {
    return '';
  }

  const total = data.paginator.total === 0 ? 0 : ((data.paginator.currentPage-1) * data.paginator.perPage+1)
  const perPage = data.paginator.currentPage*data.paginator.perPage;

  return `Showing ${total} - ${Math.min(data.paginator.total, perPage)} of ${data.paginator.total}`;
})

const showPropertyListModal = async (id, title, e) => {
    globalStore.setModal(
      {
        name: 'propertyListEnquiryModal',
        showFooter: false,
        title: title,
        id: id,
      }
    )

  await nextTick()
  localStorage.setItem('preSiteTitle', document.title);
  const ele = e.target;

  if (e.target.dataset.metaTitle) {
    document.title = e.target.dataset.metaTitle;
  }

  if (e.target.classList.contains('request-pricing')) {
    document.getElementById('pricing-information').checked = true;
  }

  document.getElementById('property_name').value = ele.dataset.propertyName
  assignHiddenFields(ele)
}

onBeforeMount(() => {
  if(window.innerWidth <= 991 ) {
    data.shouldStick = false;
    data.showMap = false;
  }
});

onMounted(() => {
  // if (data.$refs.tinySliderFeatured) {
  //   const slideCount = parseInt(data.$refs.tinySliderFeatured.slider.getInfo().slideCount, 10);
  //   localStorage.setItem('premiumVillagesCount', '0');
  //   localStorage.removeItem('premiumVillagesIndex');
  //   if (slideCount <= 3) {
  //     window.addEventListener('scroll', data.handleScroll);
  //   } else {
  //     data.$refs.tinySliderFeatured.slider.events.on('indexChanged', data.tinyIndexChange);
  //   }
  // }
  // const vue = data;

  if (props.impressionList !== undefined && props.impressionList.items.length > 0) {
    productImpression(props.impressionList);
  }

  if (props.type !== 'villages') {
    return;
  }

  const searchParams = new URLSearchParams(window.location.search);

  if (props.selectedRegion) {
    searchParams.set('region', props.selectedRegion);
  }

  if (props.selectedDistrict) {
    searchParams.set('district', props.selectedDistrict);
  }

  if (props.selectedSuburbs) {
    searchParams.set('suburbs', JSON.stringify(props.selectedSuburbs));
  }

  searchParams.set('currentUrl', window.location.href);


  data.isLoading = true;
  axios.post(`/api/village-list`, searchParams).then((response) => {
    data.villageList = response.data.villages
    data.paginator = response.data.paginator
    data.mapCentre = response.data.mapCentre
    data.mapZoom = response.data.mapZoom
    productImpression(response.data.impressionData);
    data.isLoading = false
  });
});

</script>
